import { RouteObject } from '@rocketlane/rocket-router';
import { Suspense } from 'react';
import { PageLoading } from 'components/atoms/loading';
import { lazyWithRetry } from 'utils/lazyWithRetry';
import { AccountActivatePage } from './account-activate';
import { AddApiKey, GoodbyePage, ImplicitCallback, LogoutPage } from './auth';
import { CpShareLinkPage } from './customer-portal/cp-share-page';
import { ForgotPasswordPage } from './forgot-password';
import { LinkActionPage } from './link-action';
import { MagicLinkPage } from './magic-link';
import { CustomerPortalMagicLink } from './magic-link/customer-portal-login';
import { MagicLinkGeneratePage } from './magic-link-generate';
import { ResetPasswordPage } from './reset-password';
import { ROUTE_PATHS } from './routes-paths';
import { SessionLogin } from './session-login';
import { SetupProfilePage } from './setup-profile';

const LazyLogin = lazyWithRetry(() =>
  import('routes/auth/login').then(({ Login }) => ({ default: Login })),
);

const LazyTwoFactAuthPage = lazyWithRetry(() =>
  import('components/pages/two-factor-auth').then((m) => ({
    default: m.TwoFactAuthPage,
  })),
);

const LazyWebForm = lazyWithRetry(() =>
  import('./web-form').then(({ WebForm }) => ({ default: WebForm })),
);

export const nonProtectedRoutes: RouteObject[] = [
  {
    path: `${ROUTE_PATHS.IMPLICIT}/${ROUTE_PATHS.CALLBACK}`,
    element: <ImplicitCallback />,
  },
  {
    path: ROUTE_PATHS.LOGIN,
    element: <LazyLogin />,
  },
  {
    path: ROUTE_PATHS.MAGIC_LINK,
    element: <MagicLinkPage />,
  },
  {
    path: `${ROUTE_PATHS.CP}/${ROUTE_PATHS.SHARE}`,
    element: <CpShareLinkPage />,
  },
  {
    path: `${ROUTE_PATHS.CP}/${ROUTE_PATHS.EMBED}/*`,
    element: <CustomerPortalMagicLink />,
  },
  {
    path: `${ROUTE_PATHS.MAGIC_LINK}/${ROUTE_PATHS.NEW}`,
    element: <MagicLinkGeneratePage />,
  },
  {
    path: `${ROUTE_PATHS.MAGIC_LINK}/${ROUTE_PATHS.TWO_FA}`,
    element: (
      <Suspense fallback={<PageLoading />}>
        <LazyTwoFactAuthPage />
      </Suspense>
    ),
  },
  {
    path: `${ROUTE_PATHS.SETUP_PROFILE}`,
    element: <SetupProfilePage />,
  },
  {
    path: ROUTE_PATHS.FORGOT_PASSWORD,
    caseSensitive: true,
    element: <ForgotPasswordPage />,
  },
  {
    path: ROUTE_PATHS.RESET_PASSWORD,
    element: <ResetPasswordPage />,
  },
  {
    path: ROUTE_PATHS.LOGOUT,
    element: <LogoutPage />,
  },
  {
    path: ROUTE_PATHS.GOODBYE,
    element: <GoodbyePage />,
  },
  {
    path: ROUTE_PATHS.LINK_ACTION,
    element: <LinkActionPage />,
  },
  {
    path: ROUTE_PATHS.ACTIVATE,
    element: <AccountActivatePage />,
  },
  {
    path: ROUTE_PATHS.LOGIN_SESSION,
    element: <SessionLogin />,
  },
  {
    path: 'forms/:customerName/:instanceHash',
    element: <LazyWebForm />,
  },
  {
    path: 'add-api-key/:apiKey',
    element: <AddApiKey />,
  },
];
